/* SedaNoche — interacciones (vanilla, sin librerías) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Reveals al hacer scroll (un solo observer compartido) */
  function initReveals(root) {
    var els = (root || document).querySelectorAll('.sn-reveal, .sn-reveal-img, .sn-split-line, [data-sn-observe]');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('sn-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('sn-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Parallax suave: elementos con [data-sn-parallax="intensidad"] */
  function initParallax() {
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-sn-parallax]'));
    var ritual = Array.prototype.slice.call(document.querySelectorAll('[data-sn-ritual]'));
    if ((!els.length && !ritual.length) || reduce) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var k = parseFloat(el.getAttribute('data-sn-parallax')) || 0;
        var centro = r.top + r.height / 2 - vh / 2;
        var img = el.tagName === 'IMG' ? el : el.querySelector('img');
        var lim = img ? Math.max(0, (img.offsetHeight - el.parentElement.offsetHeight) / 2) : 9999;
        if (el.tagName !== 'IMG' && img) lim = Math.max(0, (img.offsetHeight - el.offsetHeight) / 2);
        var py = Math.max(-lim, Math.min(lim, -centro * k / 100));
        el.style.setProperty('--sn-py', py.toFixed(1) + 'px');
      });
      ritual.forEach(function (el) {
        var r = el.getBoundingClientRect();
        var p = (vh * 0.75 - r.top) / (r.height + vh * 0.1);
        p = Math.max(0, Math.min(1, p));
        el.style.setProperty('--sn-progreso', p.toFixed(3));
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* Tarjetas con inclinación 3D y brillo al cursor */
  function initTilt() {
    if (reduce || window.matchMedia('(hover: none)').matches) return;
    document.querySelectorAll('[data-sn-tilt]').forEach(function (card) {
      var max = parseFloat(card.getAttribute('data-sn-tilt')) || 6;
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width;
        var y = (e.clientY - r.top) / r.height;
        card.style.transform = 'rotateX(' + ((0.5 - y) * max).toFixed(2) + 'deg) rotateY(' + ((x - 0.5) * max).toFixed(2) + 'deg) translateY(-6px)';
        card.style.setProperty('--sn-mx', (x * 100).toFixed(1) + '%');
        card.style.setProperty('--sn-my', (y * 100).toFixed(1) + '%');
      });
      card.addEventListener('mouseleave', function () { card.style.transform = ''; });
    });
  }

  /* Cifras animadas */
  function initContadores() {
    var els = document.querySelectorAll('[data-sn-contar]');
    if (!els.length) return;
    function animar(el) {
      var fin = parseFloat(el.getAttribute('data-sn-contar'));
      if (isNaN(fin)) return;
      if (reduce) { el.textContent = fin; return; }
      var t0 = null, dur = 1800;
      function paso(t) {
        if (!t0) t0 = t;
        var p = Math.min(1, (t - t0) / dur);
        var e = 1 - Math.pow(1 - p, 4);
        el.textContent = Math.round(fin * e);
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(animar); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { animar(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.6 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Selector de colores de la portada */
  function initColores() {
    document.querySelectorAll('[data-sn-colores]').forEach(function (wrap) {
      var botones = wrap.querySelectorAll('.sn-color');
      var imgs = wrap.querySelectorAll('.sn-colores__escena img');
      var halo = wrap.querySelector('.sn-colores__halo');
      var cta = wrap.querySelector('[data-sn-color-link]');
      botones.forEach(function (b, i) {
        b.addEventListener('click', function () {
          botones.forEach(function (x) { x.classList.remove('is-activo'); x.setAttribute('aria-pressed', 'false'); });
          imgs.forEach(function (x) { x.classList.remove('is-activa'); });
          b.classList.add('is-activo');
          b.setAttribute('aria-pressed', 'true');
          if (imgs[i]) imgs[i].classList.add('is-activa');
          if (halo) halo.style.setProperty('--sn-halo', b.getAttribute('data-halo'));
          if (cta && b.getAttribute('data-link')) cta.setAttribute('href', b.getAttribute('data-link'));
        });
      });
    });
  }

  /* Acordeones con animación de altura */
  function initAcordeones() {
    document.querySelectorAll('.sn-faq__item').forEach(function (d) {
      var s = d.querySelector('summary');
      var c = d.querySelector('.sn-faq__resp');
      if (!s || !c || reduce) return;
      s.addEventListener('click', function (e) {
        e.preventDefault();
        if (d.open) {
          var h = c.scrollHeight;
          c.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 450, easing: 'cubic-bezier(.22,1,.36,1)' }).onfinish = function () { d.open = false; };
        } else {
          d.open = true;
          var h2 = c.scrollHeight;
          c.animate([{ height: '0px', opacity: 0 }, { height: h2 + 'px', opacity: 1 }], { duration: 550, easing: 'cubic-bezier(.22,1,.36,1)' });
        }
      });
    });
  }

  /* Página de producto: galería, variantes, cantidad, carrito, barra fija */
  function initProducto() {
    var root = document.querySelector('[data-sn-pdp]');
    if (!root) return;
    var principal = root.querySelector('.sn-pdp__principal');
    var imgP = principal && principal.querySelector('img');
    var minis = Array.prototype.slice.call(root.querySelectorAll('.sn-pdp__mini'));
    var actual = 0;

    function mostrar(i) {
      if (!minis.length || !imgP) return;
      actual = (i + minis.length) % minis.length;
      var m = minis[actual];
      minis.forEach(function (x) { x.classList.remove('is-activa'); });
      m.classList.add('is-activa');
      principal.classList.add('is-cambiando');
      setTimeout(function () {
        imgP.src = m.getAttribute('data-src');
        imgP.srcset = m.getAttribute('data-srcset') || '';
        imgP.alt = m.getAttribute('data-alt') || '';
        principal.classList.remove('is-cambiando');
      }, 260);
      m.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }
    minis.forEach(function (m, i) { m.addEventListener('click', function () { mostrar(i); }); });
    var prev = root.querySelector('[data-sn-prev]');
    var next = root.querySelector('[data-sn-next]');
    if (prev) prev.addEventListener('click', function (e) { e.stopPropagation(); mostrar(actual - 1); });
    if (next) next.addEventListener('click', function (e) { e.stopPropagation(); mostrar(actual + 1); });

    /* Zoom al pasar el ratón */
    if (principal && imgP && window.matchMedia('(hover: hover)').matches) {
      principal.addEventListener('mousemove', function (e) {
        if (!principal.classList.contains('is-zoom')) return;
        var r = principal.getBoundingClientRect();
        imgP.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      });
      principal.addEventListener('click', function () { principal.classList.toggle('is-zoom'); });
      principal.addEventListener('mouseleave', function () { principal.classList.remove('is-zoom'); });
    }

    /* Variantes */
    var datos = root.querySelector('[data-sn-variantes]');
    var variantes = datos ? JSON.parse(datos.textContent) : [];
    var inputId = root.querySelector('input[name="id"]');
    var precio = root.querySelectorAll('[data-sn-precio]');
    var tachado = root.querySelectorAll('[data-sn-tachado]');
    var ahorro = root.querySelector('[data-sn-ahorro]');
    var boton = root.querySelector('[data-sn-add]');
    var textoBoton = boton ? boton.querySelector('span') : null;
    var txtComprar = root.getAttribute('data-txt-comprar');
    var txtAgotado = root.getAttribute('data-txt-agotado');
    var formato = root.getAttribute('data-money-format') || '${{amount}}';
    var cero = root.getAttribute('data-money-zero');
    if (cero) formato = cero.replace('0.00', '{{amount}}').replace('0,00', '{{amount_with_comma_separator}}');

    function dinero(c) {
      var n = (c / 100).toFixed(2);
      var partes = n.split('.');
      var miles = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return formato.replace(/\{\{\s*amount_no_decimals\s*\}\}/, miles)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, miles.replace(/,/g, '.') + ',' + partes[1])
        .replace(/\{\{\s*amount\s*\}\}/, miles + '.' + partes[1]);
    }

    function actualizarVariante() {
      var grupos = root.querySelectorAll('[data-sn-opcion]');
      var sel = [];
      grupos.forEach(function (g) {
        var c = g.querySelector('input:checked');
        sel.push(c ? c.value : null);
        var lbl = g.querySelector('legend span');
        if (lbl && c) lbl.textContent = c.getAttribute('data-label') || c.value;
      });
      var v = variantes.find(function (x) {
        return x.options.every(function (o, i) { return o === sel[i]; });
      });
      if (!v) return;
      if (inputId) inputId.value = v.id;
      precio.forEach(function (p) { p.textContent = dinero(v.price); });
      var hayTachado = v.compare_at_price && v.compare_at_price > v.price;
      tachado.forEach(function (t) { t.textContent = hayTachado ? dinero(v.compare_at_price) : ''; t.hidden = !hayTachado; });
      if (ahorro) {
        ahorro.hidden = !hayTachado;
        if (hayTachado) ahorro.textContent = ahorro.getAttribute('data-prefijo') + ' ' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%';
      }
      if (boton) {
        boton.disabled = !v.available;
        if (textoBoton) textoBoton.textContent = v.available ? txtComprar : txtAgotado;
      }
      var barraBtn = document.querySelector('[data-sn-barra-btn]');
      if (barraBtn) barraBtn.disabled = !v.available;
      /* Cambiar a la foto de la variante */
      if (v.featured_media) {
        var idx = minis.findIndex(function (m) { return m.getAttribute('data-media-id') == v.featured_media.id; });
        if (idx > -1 && idx !== actual) mostrar(idx);
      }
      if (window.history && window.history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      }
    }
    root.querySelectorAll('[data-sn-opcion] input').forEach(function (i) {
      i.addEventListener('change', actualizarVariante);
    });

    /* Cantidad */
    var qty = root.querySelector('[data-sn-qty]');
    root.querySelectorAll('[data-sn-qty-btn]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = parseInt(qty.value, 10) || 1;
        n += parseInt(b.getAttribute('data-sn-qty-btn'), 10);
        qty.value = Math.max(1, n);
      });
    });

    /* Añadir al carrito vía AJAX y abrir el carrito de Dawn */
    var form = root.querySelector('form[action*="/cart/add"]');
    var msg = root.querySelector('[data-sn-msg]');
    if (form && window.fetch) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (boton) boton.classList.add('is-cargando');
        var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        var fd = new FormData(form);
        if (cart && cart.getSectionsToRender) {
          fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
          fd.append('sections_url', window.location.pathname);
          if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
        }
        fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }
        }).then(function (r) { return r.json(); }).then(function (res) {
          if (boton) boton.classList.remove('is-cargando');
          if (res.status) { if (msg) msg.textContent = res.description || res.message; return; }
          if (msg) msg.textContent = '';
          if (cart && cart.renderContents) {
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            cart.renderContents(res);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        }).catch(function () { form.submit(); });
      });
    }

    /* Barra fija de compra */
    var barra = document.querySelector('.sn-barra-fija');
    if (barra && boton && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        var e = es[0];
        barra.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      });
      io.observe(boton);
      var bb = barra.querySelector('[data-sn-barra-btn]');
      if (bb) bb.addEventListener('click', function () { if (form) form.requestSubmit ? form.requestSubmit() : form.submit(); });
    }
  }

  /* Hero: la imagen sigue suavemente al ratón */
  function initHero() {
    if (reduce || window.matchMedia("(hover: none)").matches) return;
    document.querySelectorAll("[data-sn-hero=\"true\"]").forEach(function (hero) {
      var media = hero.querySelector(".sn-hero__media");
      var luz = hero.querySelector(".sn-hero__luz");
      if (!media) return;
      hero.addEventListener("mousemove", function (e) {
        var r = hero.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        media.style.setProperty("--sn-hx", (-x * 18).toFixed(1) + "px");
        media.style.setProperty("--sn-hy", (-y * 12).toFixed(1) + "px");
        if (luz) luz.style.marginLeft = (x * 30).toFixed(1) + "px";
      });
      hero.addEventListener("mouseleave", function () {
        media.style.setProperty("--sn-hx", "0px");
        media.style.setProperty("--sn-hy", "0px");
        if (luz) luz.style.marginLeft = "0px";
      });
    });
  }

  /* Comparador antes / después */
  function initAntesDespues() {
    document.querySelectorAll("[data-sn-ad]").forEach(function (comp) {
      if (comp.dataset.snListo) return;
      comp.dataset.snListo = "1";
      var rango = comp.querySelector(".sn-ad__rango");
      var inicial = parseFloat(comp.getAttribute("data-inicio")) || 50;
      function poner(v) { comp.style.setProperty("--pos", v + "%"); }
      poner(inicial);
      rango.addEventListener("input", function () { poner(rango.value); });
      rango.addEventListener("pointerdown", function () { comp.classList.add("is-arrastrando"); });
      window.addEventListener("pointerup", function () { comp.classList.remove("is-arrastrando"); });
      /* Pista animada la primera vez que se ve */
      if (reduce || !("IntersectionObserver" in window)) return;
      var io = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        io.disconnect();
        var pasos = [inicial, 78, 22, inicial], i = 0, t0 = null, dur = 900;
        function anim(t) {
          if (!t0) t0 = t;
          var p = Math.min(1, (t - t0) / dur);
          var e = p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
          var v = pasos[i] + (pasos[i + 1] - pasos[i]) * e;
          poner(v); rango.value = v;
          if (p < 1) return requestAnimationFrame(anim);
          i++; t0 = null;
          if (i < pasos.length - 1) requestAnimationFrame(anim);
        }
        setTimeout(function () { requestAnimationFrame(anim); }, 500);
      }, { threshold: 0.5 });
      io.observe(comp);
    });
  }

  function init() {
    initReveals();
    initParallax();
    initTilt();
    initContadores();
    initColores();
    initAcordeones();
    initProducto();
    initHero();
    initAntesDespues();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  /* Editor de Shopify: reiniciar al editar una sección */
  document.addEventListener('shopify:section:load', function (e) {
    initReveals(e.target); initTilt(); initContadores(); initColores(); initAcordeones(); initParallax(); initAntesDespues();
    e.target.querySelectorAll('.sn-reveal, .sn-reveal-img, .sn-split-line').forEach(function (el) { el.classList.add('sn-visible'); });
  });
})();
